import React from 'react';
import * as Yup from 'yup';
import { HandleFormDetail, TextInput, Selection } from 'components';
import { Box, Button } from '@mui/material';
import { Formik } from 'formik';
import ApiServices from 'services';
import { LEVEL_DASHBOARD } from 'commons/constants';

const LEVEL_DASHBOARD_OPTIONS = [
  { value: 0, content: LEVEL_DASHBOARD[0] },
  { value: 1, content: LEVEL_DASHBOARD[1] },
];

const FORM_WIDTH = '500px';
export const FormDetail = ({ selected, setSelected, initData, data, ...props }) => {
  const dataParent = data.filter((item) => !item.parentServiceId);

  const createFn = async (values, { setSubmitting }) => {
    setSubmitting(true);
    try {
      const { status } = await ApiServices.createService(values);
      if (status === 200) {
        window.UIMessage?.success('Thêm mới thành công');
        setSelected(null);
        initData();
        // window.location.reload();
      } else {
        window.UIMessage?.error('Thêm mới thất bại !!!');
      }
    } catch (error) {
      console.log(error);
    }
    setSubmitting(false);
  };

  const updateFn = async (values, { setSubmitting }) => {
    delete values.updatedOn;
    setSubmitting(true);
    try {
      const { data } = await ApiServices.updateService(values.id, values);
      if (data) {
        window.UIMessage?.success('Cập nhật thành công');
        setSelected(null);
        initData();
        // window.location.reload();
      } else {
        window.UIMessage?.error('Cập nhật thất bại !!!');
      }
    } catch (error) {
      console.log(error);
    }
    setSubmitting(false);
  };

  return (
    <>
      <HandleFormDetail
        {...{ selected, setSelected, width: FORM_WIDTH }}
        showTitleTab={selected?.isNew ? 'Tạo mới' : `Menu: ${selected?.name}`}
      >
        <Formik
          initialValues={{
            code: '',
            name: '',
            companyId: '',
            parentServiceId: '',
            level: '',
            note: '',
            ...selected,
          }}
          validationSchema={Yup.object().shape({
            code: Yup.string()
              .max(15, 'Mã chỉ được nhập tối đa 15 ký tự')
              .required('Vui lòng nhập mã'),
            name: Yup.string().max(255).required('Vui lòng nhập tên dịch vụ'),
            companyId: Yup.string().max(255).required('Vui lòng chọn công ty'),
          })}
          onSubmit={(values, { setSubmitting }) => {
            if (selected?.isNew) {
              createFn(values, { setSubmitting });
            } else {
              updateFn(values, { setSubmitting });
            }
          }}
        >
          {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
            <form onSubmit={handleSubmit} style={{ width: '100%' }}>
              <TextInput
                error={Boolean(touched.code && errors.code)}
                helperText={touched.code && errors.code}
                label="Mã"
                name="code"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.code}
                disabled={!selected?.isNew}
              />
              <TextInput
                error={Boolean(touched.name && errors.name)}
                helperText={touched.name && errors.name}
                label="Tên Dịch Vụ"
                name="name"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.name}
              />
              <Selection
                error={Boolean(touched.companyId && errors.companyId)}
                helperText={touched.companyId && errors.companyId}
                label="Công ty"
                name="companyId"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.companyId}
                syncData={ApiServices.getCompanies}
              />
              <Selection
                error={Boolean(touched.parentServiceId && errors.parentServiceId)}
                helperText={touched.parentServiceId && errors.parentServiceId}
                label="Parent"
                name="parentServiceId"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.parentServiceId}
                dataArrObject={dataParent}
                fieldValue="id"
                fieldView="name"
                disabledItemNone={false}
              />
              <Selection
                error={Boolean(touched.level && errors.level)}
                helperText={touched.level && errors.level}
                label="Cấp độ"
                name="level"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.level}
                dataArrObject={LEVEL_DASHBOARD_OPTIONS}
              />
              <Box sx={{ py: 2 }}>
                <Button
                  color="primary"
                  disabled={isSubmitting}
                  fullWidth
                  size="small"
                  type="submit"
                  variant="contained"
                >
                  {selected?.isNew ? 'Thêm mới' : 'Cập nhật'}
                </Button>
              </Box>
            </form>
          )}
        </Formik>
      </HandleFormDetail>
    </>
  );
};
